import ActualQrCode from './actual-qr-code';
import { useSelector } from 'react-redux';
import getImage from 'helpers/getImage';
import './loyalty-card.css';

const LoyaltyCard = ({
  mainTextColor,
  labelColor,
  bgColor,
  selectedImageTheme,
  customReferralId,
  userId,
  customName,
  customPoints,
}) => {
  const { storeConfig } = useSelector((state) => state.layoutReducer);
  const { logo, logoPath } = storeConfig || {};

  // More robust logo handling
  let storeLogo = '';
  if (logoPath) {
    storeLogo = getImage(logoPath);
  } else if (logo) {
    storeLogo = getImage(logo);
  }
  // Additional validation - ensure we have a valid URL
  if (storeLogo && !storeLogo.trim()) {
    storeLogo = '';
  }

  // Use custom values if provided, otherwise use default values
  const referralId = customReferralId || '1231 065 366';
  const displayName = customName
    ? customName.toUpperCase()
    : 'JOHNNY APPLESEED';
  const pointsBalance = customPoints !== undefined ? customPoints : 7584;

  // Generate QR code content with member information
  const qrCodeContent = `Coming soon TM`;

  return (
    <div className='loyalty-card w-full' style={{ backgroundColor: bgColor }}>
      <div className='loyalty-card-header flex justify-between'>
        <div
          className='logo-container'
          style={{
            display: 'flex',
            alignItems: 'center',
            minHeight: '50px',
            minWidth: '80px',
            position: 'relative',
          }}
        >
          {storeLogo ? (
            <img
              className='loyalty-card-logo'
              src={storeLogo}
              alt='store logo'
              style={{
                display: 'block',
                objectFit: 'contain',
                height: 'auto',
                width: 'auto',
                objectPosition: 'left center',
              }}
              onError={(e) => {
                console.error('Logo failed to load:', storeLogo);
                console.error('Image error event:', e);
                console.error('Error details:', {
                  src: e.target.src,
                  naturalHeight: e.target.naturalHeight,
                  naturalWidth: e.target.naturalWidth,
                  complete: e.target.complete,
                });
                // Try to show a placeholder or hide the container
                e.target.style.display = 'none';
              }}
              onLoad={(e) => {
                console.log('Logo loaded successfully:', storeLogo);
                console.log('Image dimensions:', {
                  naturalHeight: e.target.naturalHeight,
                  naturalWidth: e.target.naturalWidth,
                  displayHeight: e.target.height,
                  displayWidth: e.target.width,
                });
                e.target.style.display = 'block';
              }}
            />
          ) : (
            <div
              style={{
                minHeight: '50px',
                minWidth: '80px',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                fontSize: '12px',
                color: labelColor || '#666',
                opacity: 0.5,
                border: '1px dashed rgba(255,255,255,0.3)',
                borderRadius: '4px',
              }}
            >
              No Logo
            </div>
          )}
        </div>
        <div>
          <div className='membership-text' style={{ color: labelColor }}>
            Membership
          </div>
          <div className='membership-id' style={{ color: mainTextColor }}>
            {referralId}
          </div>
        </div>
      </div>
      <div className='loyalty-card-design w-full'>
        {selectedImageTheme && (
          <img
            className='w-full h-full object-cover'
            src={selectedImageTheme}
            alt='logo'
          />
        )}
      </div>
      <div className='loyalty-secondary'>
        <div className='flex-1'>
          <div
            className='text-[12px] font-medium'
            style={{ color: labelColor }}
          >
            NAME
          </div>
          <div
            style={{ color: mainTextColor }}
            className='font-medium text-[17px]'
          >
            {displayName}
          </div>
        </div>
        <div>
          <div
            className='text-[12px] font-medium'
            style={{ color: labelColor }}
          >
            POINTS BALANCE
          </div>
          <div
            style={{ color: mainTextColor }}
            className='text-right font-medium text-[17px]'
          >
            {pointsBalance.toLocaleString()}
          </div>
        </div>
      </div>
      <div className='loyalty-qrcode'>
        <div className='flex justify-center'>
          <ActualQrCode
            text={`<qr>userId:${userId}</qr>`}
            color='#000000'
            size={150}
          />
        </div>
      </div>
    </div>
  );
};

export default LoyaltyCard;
